export const LAYOUT_ORDER = [
	{ id: 'APP_UPDATE', label: 'APP_UPDATE' },
	{ id: 'REFERRAL', label: 'REFERRAL' },
	{ id: 'LUDO', label: 'LUDO' },
	{ id: 'TURBO', label: 'TURBO' },
	{ id: 'NINJA', label: 'NINJA' },
	{ id: 'SNLT', label: 'SNLT' },
	{ id: 'CARROM', label: 'CARROM' },
	{ id: 'TC', label: 'TC' },
	{ id: 'MTT', label: 'MTT' },
	{ id: 'BANNERS', label: 'BANNERS' },
	{ id: 'QUESTION_BANK', label: 'QUESTION_BANK' },
	{ id: 'NOTICES', label: 'NOTICES' }
];

export const GAMES = ['LUDO', 'NINJA', 'TURBO', 'SNLT', 'CARROM', 'TC'];

export const superAppLiveGamesBuckets = [
	'control',
	'turboOnNinjaFirst',
	'turboOnTurboFirst',
	'ludoOnlyIfNotPlayedAnyGame',
	'ludoOnlyOthersLockedTillNGameplays'
];

export const BUCKET_OPTIONS = superAppLiveGamesBuckets.map((bucket) => {
	return { id: bucket, label: bucket };
});

export const WIDTH = [
	{ id: '1', label: '100%' },
	{ id: '2', label: '50%' }
];

export const WIDGET_TYPES = [
	{ id: 'hero', label: 'hero' },
	{ id: 'grid', label: 'grid' }
];
